<template>
  <div class="withdraw_wrap">
    <!-- <div class="base-header">
      <div class="big_tit" @click="$router.push('recharge')">{{ $t('充值') }}</div>
      <div :class="is_active ? 'big_tit is-active' : 'big_tit'">{{ $t('提现') }}</div>
    </div> -->
    <!-- <div class="logo">
      <img src="../../assets/images/logo/logo.png" />
    </div> -->
    <div class="left_div">
      <div class="left" @click="$router.push('/')">
        <svg
          width="1em"
          height="1em"
          fill=""
          aria-hidden="true"
          focusable="false"
        >
          <symbol viewBox="0 0 21.999 35.998" id="comm_icon_fh--svgSprite:all">
            <path
              id="comm_icon_fh--svgSprite:all_comm_icon_fh"
              d="M2209.279,137.564l-17.743-15.773a2.024,2.024,0,0,1-.271-.228,2.009,2.009,0,0,1,0-2.83,2.02,2.02,0,0,1,.274-.23l17.74-15.77a1.992,1.992,0,0,1,2.817,2.816l-16.422,14.6,16.422,14.6a1.992,1.992,0,0,1-2.817,2.817Z"
              transform="translate(-2190.681 -102.15)"
            ></path>
          </symbol>
          <use xlink:href="#comm_icon_fh--svgSprite:all"></use>
        </svg>
      </div>
      <van-tabs
        v-model="active"
        animated
        offset-top="1.2rem"
        lazy-render
        class="vantTabs"
        @change="tabChange"
      >
        <van-tab title="Saque" />
        <van-tab title="Registro de Saques" />
        <!-- <van-tab title="Registros de Auditoria" />
        <van-tab title="Gerenciar Conta" /> -->
      </van-tabs>
    </div>

    <div v-show="active == 0">
      <div class="ablewd">
        <div>
          <div class="left-ab">
            <div class="desc-ab">Saldo da Conta</div>
            <!-- <img class="jinbi" src="../../assets/images/common/a04.png" /> -->
            <div class="desc-num">{{ able_money }}</div>
            <div class="wdAble" @click="getWdAble()">
              <svg
                width="1.2em"
                height="1.2em"
                fill=""
                aria-hidden="true"
                focusable="false"
              >
                <symbol
                  viewBox="0 0 24 25.144"
                  id="comm_icon_sx--svgSprite:all"
                >
                  <path
                    id="comm_icon_sx--svgSprite:all_comm_icon_sx"
                    d="M1520.314-127.2l5.058-9.146,2.1,3.9a10.844,10.844,0,0,0,4.845-9.038c0-3.028-2-6.031-4-8,3.919,1.639,7.43,5.773,7.43,10.285a10.856,10.856,0,0,1-6.549,9.964l1.977,3.179Zm-8.572-10.858a10.86,10.86,0,0,1,6.548-9.965l-1.976-3.178,10.857,1.142-5.06,9.147-2.095-3.9a10.842,10.842,0,0,0-4.847,9.039c0,3.028,2,6.031,4,8C1515.255-129.409,1511.743-133.543,1511.743-138.055Z"
                    transform="translate(-1511.743 151.198)"
                  ></path>
                </symbol>
                <use xlink:href="#comm_icon_sx--svgSprite:all"></use>
              </svg>
            </div>
          </div>
          <div class="money_title">
            <span>Você precisa apostar </span>
            <span class="rmoney">R$ {{ need_bet }}</span>
            <span> sacar dinheiro</span>
          </div>
        </div>

        <!-- <div class="right-ab" v-if="need_bet > 0">
          <div class="desc-ab">Ainda precisa apostar</div>
          <div class="desc-num">{{ need_bet }}</div>
        </div> -->
      </div>
      <div class="ablewd">
        <ul>
          <li>
            <span>Retirada normal</span>
            <div class="choseDiv">
              <svg
                data-v-92dc7236=""
                width="25"
                height="14"
                viewBox="0 0 32 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="m-wrap"
              >
                <g data-v-92dc7236="" clip-path="url(#clip0_6948_48956)">
                  <path
                    data-v-92dc7236=""
                    d="M0 19L32 0V11.5C32 15 29.0462 19 25.6 19H0Z"
                    fill="#1E62F5"
                  ></path>
                  <path
                    data-v-92dc7236=""
                    d="M18 11.7521L21.1999 14.8485C21.4087 15.0505 21.7472 15.0505 21.9561 14.8485L28 9"
                    stroke="white"
                    stroke-width="1.03079"
                    stroke-linecap="round"
                    class="stroke_path"
                  ></path>
                </g>
                <defs data-v-92dc7236="">
                  <clipPath data-v-92dc7236="" id="clip0_6948_48956">
                    <rect
                      data-v-92dc7236=""
                      width="32"
                      height="19"
                      fill="white"
                    ></rect>
                  </clipPath>
                </defs>
              </svg>
            </div>
          </li>
        </ul>
      </div>
      <div class="enther">
        <!-- <div class="endes">
        {{ $t("请输入您的数量") }} ({{ $t("最低") }}{{ min_withdraw_amount }})
      </div> -->
        <!-- <van-cell-group>
        <van-field v-model="value1" label="文本" placeholder="请输入用户名" />
      </van-cell-group> -->
        <!-- <div class="addAccount" >
          <div class="left_add">
            <div>
              <svg
                width="2.8em"
                height="2.8em"
                fill=""
                aria-hidden="true"
                focusable="false"
                class="addSvg"
              >
                <symbol viewBox="0 0 40 27.611" id="img_tx_tjzh--svgSprite:all">
                  <g
                    id="img_tx_tjzh--svgSprite:all_img_tx_tjzh"
                    transform="translate(-1939.301 287.188)"
                  >
                    <path
                      id="img_tx_tjzh--svgSprite:all_Path_520"
                      data-name="Path 520"
                      d="M1977.03-283.677a3.486,3.486,0,0,0-3.461-3.51h-30.807a3.486,3.486,0,0,0-3.461,3.51v3.017h37.729Z"
                      fill-rule="evenodd"
                    ></path>
                    <path
                      id="img_tx_tjzh--svgSprite:all_Path_521"
                      data-name="Path 521"
                      d="M1958.38-262.572a11.712,11.712,0,0,1,5.108-9.678H1939.3v15.084a3.486,3.486,0,0,0,3.461,3.511H1962.5A11.694,11.694,0,0,1,1958.38-262.572Z"
                      transform="translate(0 -6.198)"
                      fill-rule="evenodd"
                    ></path>
                    <path
                      id="img_tx_tjzh--svgSprite:all_Path_522"
                      data-name="Path 522"
                      d="M1985.436-271.42a9.192,9.192,0,0,0-9.192,9.193,9.192,9.192,0,0,0,9.192,9.192,9.193,9.193,0,0,0,9.193-9.192A9.193,9.193,0,0,0,1985.436-271.42Zm5.089,9.186a1.025,1.025,0,0,1-1.017,1.032h-3.061v3.1a1.024,1.024,0,0,1-1.017,1.032h0a1.024,1.024,0,0,1-1.017-1.032v-3.1h-3.042a1.024,1.024,0,0,1-1.017-1.032v0a1.024,1.024,0,0,1,1.017-1.031h3.042v-3.086a1.024,1.024,0,0,1,1.017-1.031h0a1.024,1.024,0,0,1,1.017,1.031v3.086h3.061a1.024,1.024,0,0,1,1.017,1.031Z"
                      transform="translate(-15.328 -6.542)"
                      fill-rule="evenodd"
                    ></path>
                  </g>
                </symbol>
                <use xlink:href="#img_tx_tjzh--svgSprite:all"></use>
              </svg>
            </div>
            <div class="addText">Adicionar Conta</div>
          </div>
          <div>
            <svg
              width="1.5em"
              height="1.5em"
              fill=""
              class="left_svg"
              aria-hidden="true"
              focusable="false"
            >
              <symbol
                viewBox="0 0 21.999 35.998"
                id="comm_icon_fh--svgSprite:all"
              >
                <path
                  id="comm_icon_fh--svgSprite:all_comm_icon_fh"
                  d="M2209.279,137.564l-17.743-15.773a2.024,2.024,0,0,1-.271-.228,2.009,2.009,0,0,1,0-2.83,2.02,2.02,0,0,1,.274-.23l17.74-15.77a1.992,1.992,0,0,1,2.817,2.816l-16.422,14.6,16.422,14.6a1.992,1.992,0,0,1-2.817,2.817Z"
                  transform="translate(-2190.681 -102.15)"
                ></path>
              </symbol>
              <use xlink:href="#comm_icon_fh--svgSprite:all"></use>
            </svg>
          </div>
        </div> -->
        <div class="input_item">
          <p class="endes">
            Digite seu valor (Minimo {{ min_withdraw_amount }})
          </p>
          <input
            type="text"
            class="amount-input"
            :placeholder="$t('请输入提现数量')"
            v-model="money"
          />
        </div>

        <div class="input_item">
          <p class="endes">Nome</p>
          <input
            type="text"
            class="amount-input"
            v-model="real_name"
            :placeholder="'Introduza o nome'"
          />
        </div>

        <div class="input_item">
          <p class="endes">{{ $t("电话号码") }}</p>
          <input
            v-if="!is_withdraled"
            type="text"
            class="amount-input"
            v-model="phone_number"
            :placeholder="$t('请输入电话号码')"
          />
          <input
            v-if="is_withdraled"
            type="text"
            class="amount-input cantc"
            v-model="phone_number"
            readonly
          />
        </div>

        <div class="input_item">
          <label for="country" class="endes">Tipo de PIX </label>
          <select
            id="country"
            name="country"
            class="amount-input selectpix"
            v-model="chave_pix"
          >
            <option value="PIX_CPF" :selected="chave_pix == 'PIX_CPF'">
              PIX-CPF
            </option>
            <option value="PIX_CNPJ" :selected="chave_pix == 'PIX_CNPJ'">
              PIX-CNPJ
            </option>
            <option value="PIX_PHONE" :selected="chave_pix == 'PIX_PHONE'">
              PIX-PHONE
            </option>
            <option value="PIX_EMAIL" :selected="chave_pix == 'PIX_EMAIL'">
              PIX-EMAIL
            </option>
          </select>
        </div>

        <!-- <div class="input_item">
          <p class="endes">Tipo de PIX</p>
          <input
            type="text"
            class="amount-input"
            :placeholder="$t('Input Pix(CPF)')"
            v-model="chave_pix"
            readonly
          />
        </div> -->

        <div class="input_item">
          <p class="endes" v-show="chave_pix == 'PIX_CPF'">PIX_CPF</p>
          <p class="endes" v-show="chave_pix == 'PIX_CNPJ'">PIX_CNPJ</p>
          <p class="endes" v-show="chave_pix == 'PIX_PHONE'">PIX_PHONE</p>
          <p class="endes" v-show="chave_pix == 'PIX_EMAIL'">PIX_EMAIL</p>
          <input
            type="text"
            v-if="!is_withdraled"
            class="amount-input"
            placeholder="Por favor insira o número da sua conta PIX"
            v-model="cpf"
          />
          <input
            type="text"
            v-if="is_withdraled"
            class="amount-input cantc"
            readonly
            v-model="cpf"
          />
        </div>
        <!-- <van-field
          class=".withdraw-input"
          v-model="value1"
          label="R$"
          placeholder="Por favor, primeiro adicione a conta para saque"
        /> -->

        <!-- <div class="fee">{{ $t("提现手续费") }}: {{ withdraw_rate }}%</div> -->
        <div style="margin-top: 0.5rem" @click="submit">
          <van-button type="primary">Confirmar</van-button>
        </div>
      </div>
      <!-- <div class="" style="padding: 0.3rem 0.2rem">
        <div class="password">
          <div class="password_title">Senha de Saque</div>
          <div><van-icon name="lock" class="lock_icon" /></div>
        </div>
        <div class="fst_pw">
          <input-password
            v-model="password"
            @changeItem="pswChange"
          ></input-password>
        </div>
        <div class="password_title">
          Termos de uso：Prezados clientes, para a segurança de seus fundos e a
          chegada oportuna dos fundos, verifique novamente se sua conta de
          recebimento está correta.
        </div>
        <div style="margin-top: 0.5rem">
          <van-button type="primary">Confirmar</van-button>
        </div>
      </div> -->
    </div>
    <div v-show="active == 1">
      <div class="select_items">
        <div class="flex_select">
          <div class="select_item">
            <select
              id="history"
              name="history"
              v-model="select_history_time"
              @change="selectHistoryimeChange"
            >
              <option value="today" :selected="select_history_time == 'today'">
                Hoje
              </option>
              <option
                value="yesterday"
                :selected="select_history_time == 'yesterday'"
              >
                Ontem
              </option>
              <option value="last7" :selected="select_history_time == 'last7'">
                Últimos 7 Dias
              </option>
              <option
                value="last15"
                :selected="select_history_time == 'last15'"
              >
                Últimos 15 Dias
              </option>
              <option
                value="last30"
                :selected="select_history_time == 'last30'"
              >
                Últimos 30 Dias
              </option>
            </select>
          </div>
        </div>

        <div class="bonus">
          Total de Saques:
          <span style="margin-right: 0.3rem">R$ {{ re_list.total_money }}</span>
        </div>
      </div>
      <div v-for="(item, k) in re_list.list" :key="k" class="recharge-one">
        <div class="order-status">
          <div>Pagamento online</div>
          <div class="mmm">{{ item.money }}</div>
        </div>
        <div class="order-status">
          <div>{{ item.order_no }}</div>
          <div @click="doCopy(item.order_no)">
            <svg
              data-v-fa159fb6=""
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="13"
              viewBox="0 0 26 26"
              fill="none"
            >
              <g data-v-fa159fb6="" clip-path="url(#clip0_2451_66251)">
                <g data-v-fa159fb6="" clip-path="url(#clip1_2451_66251)">
                  <path
                    data-v-fa159fb6=""
                    d="M10.1064 5.85938H20.5844C21.7549 5.8607 22.8771 6.32627 23.7048 7.15396C24.5325 7.98165 24.9981 9.10385 24.9994 10.2744V20.7524C24.9981 21.9229 24.5325 23.0451 23.7048 23.8728C22.8771 24.7005 21.7549 25.1661 20.5844 25.1674H10.1064C8.93588 25.1661 7.81368 24.7005 6.98599 23.8728C6.15831 23.0451 5.69273 21.9229 5.69141 20.7524V10.2744C5.69273 9.10385 6.15831 7.98165 6.98599 7.15396C7.81368 6.32627 8.93588 5.8607 10.1064 5.85938ZM20.5844 22.7164C21.1052 22.7161 21.6046 22.5091 21.9729 22.1408C22.3411 21.7726 22.5481 21.2732 22.5484 20.7524V10.2744C22.5466 9.75461 22.3388 9.25675 21.9708 8.88979C21.6027 8.52282 21.1042 8.31664 20.5844 8.31637H10.1064C9.58768 8.31822 9.09073 8.5251 8.72393 8.8919C8.35713 9.25869 8.15025 9.75565 8.14841 10.2744V20.7524C8.14867 21.2721 8.35485 21.7706 8.72182 22.1387C9.08878 22.5068 9.58664 22.7145 10.1064 22.7164H20.5844Z"
                    fill="currentColor"
                  ></path>
                  <path
                    data-v-fa159fb6=""
                    d="M3.46995 20.87C3.29252 20.8705 3.11713 20.8323 2.95599 20.758C2.79485 20.6837 2.65185 20.5752 2.53695 20.44C1.54592 19.2806 1.00156 17.8053 1.00195 16.28V7.406C1.00381 5.70794 1.67904 4.07993 2.87957 2.87903C4.08009 1.67813 5.70789 1.00238 7.40595 1H16.284C17.1489 0.999689 18.005 1.17472 18.8004 1.51452C19.5959 1.85431 20.3142 2.35183 20.912 2.977C21.1245 3.2141 21.2364 3.52458 21.2241 3.84275C21.2118 4.16092 21.0762 4.46182 20.846 4.68178C20.6157 4.90174 20.309 5.0235 19.9906 5.0213C19.6722 5.0191 19.3671 4.89312 19.14 4.67C18.7721 4.28252 18.3289 3.97433 17.8376 3.76436C17.3463 3.55439 16.8172 3.44708 16.283 3.449H7.40595C6.35726 3.45059 5.35201 3.86809 4.61075 4.60992C3.86949 5.35174 3.45275 6.3573 3.45195 7.406V16.284C3.45168 17.2247 3.78713 18.1346 4.39795 18.85C4.54919 19.0279 4.64647 19.2453 4.67834 19.4767C4.71021 19.708 4.67536 19.9436 4.57787 20.1558C4.48039 20.368 4.32433 20.548 4.12806 20.6745C3.93179 20.801 3.70347 20.8688 3.46995 20.87Z"
                    fill="currentColor"
                  ></path>
                </g>
              </g>
              <defs data-v-fa159fb6="">
                <clipPath data-v-fa159fb6="" id="clip0_2451_66251">
                  <rect
                    data-v-fa159fb6=""
                    width="26"
                    height="26"
                    fill="currentColor"
                  ></rect>
                </clipPath>
                <clipPath data-v-fa159fb6="" id="clip1_2451_66251">
                  <rect
                    data-v-fa159fb6=""
                    width="26"
                    height="26"
                    fill="currentColor"
                  ></rect>
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
        <div class="order-status" v-if="item.remark">
          <div>{{ item.remark }}</div>
        </div>
        <div class="money3">
          <div class="order">
            {{ item.time }}
          </div>
          <div :class="item.status == 1 ? 'status' : 'unpay'">
            <b v-if="item.status == 1">{{ $t("已付款") }}</b>
            <b v-else-if="item.status == 0">Pagando</b>
            <b v-else-if="item.status == 2">Pagamento falhou</b>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="sbtn" @click="submit">
      {{ $t("提现") }}
    </div> -->

    <pay-layer
      ref="payLayer"
      v-model="show_pay"
      @inputEnd="handleInputEnd"
      @close="handleClose"
      @forgetPassword="handleForget"
    />

    <!-- <ft></ft> -->
    <!-- <ftNav :active="2"></ftNav> -->
  </div>
</template>

<script>
import Vue from "vue";
import Fetch from "../../utils/fetch";
import {
  NavBar,
  Tab,
  Tabs,
  Field,
  Button,
  Popup,
  DropdownMenu,
  DropdownItem,
} from "vant";
import ft from "../../components/ft.vue";
import ftNav from "../../components/footer_nav/footer_nav";
import payLayer from "vue-pay-layer";
import InputPassword from "../../components/password";

Vue.use(payLayer)
  .use(NavBar)
  .use(Tab)
  .use(Tabs)
  .use(Field)
  .use(Button)
  .use(Popup)
  .use(DropdownMenu)
  .use(DropdownItem);
export default {
  name: "cost",
  data() {
    return {
      active: 0,
      able_money: 0, //可以提现金额
      money: null,
      phone_number: "",
      chave_pix: "PIX_CPF",
      real_name: "",
      cpf: "Loading...",
      min_withdraw_amount: null,
      withdraw_rate: null,
      is_active: true,
      is_withdraled: false,
      pay_password: "",
      show_pay: false,
      need_bet: 0,
      value1: "",
      password: "",
      select_history_time: "today",
      show: false,
      idCard: "",
      cy: "",
      select: "",
      re_list: [],
      totalMoney: 0.0,
      option1: [
        { text: "CPF", value: 0 },
        { text: "新款商品", value: 1 },
        { text: "活动商品", value: 2 },
      ],
    };
  },
  components: {
    ft,
    ftNav,
    InputPassword,
  },
  created() {
    this.$bus.$emit("send2ftnav", 3);
  },
  watch: {
    chave_pix: function (n, old) {
      console.log(n, old);
      if (n == "PIX_PHONE") {
        this.cpf = "+55";
      }
    },
  },
  mounted() {
    //验证一下有没有设置支付密码
    Fetch("/Withdrow/hasWithdrawPassword").then((res) => {
      console.log(res);
      if (res.data.is_set == 0) {
        this.$router.push("setpasswd");
      } else {
        this.getWdAble();
      }
    });
  },
  methods: {
    addaccount() {
      this.show = true;
    },
    pswChange(password) {
      console.log(password);
    },
    tabChange(v) {
      this.active = v;
      if (this.active == 1) {
        Fetch("/withdrow/getwithdrawbydate", {
          type: this.select_history_time,
        }).then((r) => {
          if (r.data) {
            this.re_list = r.data;
          }
        });
      }
    },
    back() {
      this.$router.go(-1);
    },
    onClickLeft() {
      this.$router.push("/");
    },
    doCopy(val) {
      let _this = this;
      this.$copyText(String(val)).then(
        function (e) {
          _this.$toast({
            background: "#07c160",
            message: _this.$t("复制成功"),
          });
        },
        function (e) {
          // console.log(e);
        }
      );
    },
    //获取可以提现的金额
    getWdAble() {
      Fetch("/Withdrow/getWithdrawInfo").then((res) => {
        this.able_money = res.data.can_withdraw_amount;
        this.min_withdraw_amount = res.data.min_withdraw_amount;
        this.chave_pix = res.data.chave_pix ? res.data.chave_pix : "PIX_CPF";
        this.withdraw_rate = res.data.withdraw_rate;
        this.real_name = res.data.real_name;
        this.phone_number = res.data.phone_number;
        this.need_bet = res.data.need_bet;
        setTimeout(() => {
          this.cpf = res.data.cpf;
        }, 500);
      });
    },
    handleInputEnd(pay_password) {
      Fetch("/Withdrow/addWithdraw", {
        money: this.money,
        phone_number: this.phone_number,
        chave_pix: this.chave_pix,
        cpf: this.cpf,
        email: this.email,
        real_name: this.real_name,
        pay_password: pay_password,
      }).then((res) => {
        if (res.code == 1) {
          this.$message({
            title: "R$" + this.money,
            message: this.$t("提现成功"),
            type: "success",
          });
          setTimeout(() => {
            this.$router.push("/");
          });
        } else {
          setTimeout(() => {
            this.$message.error({
              message: res.msg,
            });
            this.$refs.payLayer.fail("");
          }, 2000);
        }
      });
    },
    handleClose() {
      this.show_pay = false;
    },
    handleForget() {
      this.$message.info({
        title: "Redefinir senha de saque",
        message:
          "Entre em contato com o atendimento ao cliente da plataforma para resolver o problema de redefinição da senha de saque.",
        duration: 5000,
      });
    },
    selectHistoryimeChange() {
      this.re_list = [];
      Fetch("/withdrow/getwithdrawbydate", {
        type: this.select_history_time,
      }).then((r) => {
        if (r.data) {
          this.re_list = r.data;
        }
      });
    },
    //提现
    submit() {
      console.log(123);
      if (this.need_bet > 0) {
        this.$message({
          title: "Aviso gentil",
          message:
            "Você ainda precisa apostar R$" +
            this.need_bet +
            " para poder sacar",
        });
        return false;
      }
      //没有可提现的金额
      if (this.able_money <= 0) {
        this.$toast({
          background: "#a244aa",
          message: this.$t("当前可提现金额为0"),
          duration: 3000,
        });
        return false;
      }
      //提现金额验证
      let amount_reg = /^[1-9][0-9]*([.][0-9]{1,2})?$/;
      if (!amount_reg.test(this.money)) {
        this.$toast({
          background: "#a244aa",
          message: this.$t("提现金额不正确"),
          duration: 3000,
        });
        return false;
      }
      //提现金额 大于可提现金额
      if (Number(this.money) > Number(this.able_money)) {
        this.$toast({
          background: "#a244aa",
          message: this.$t("提现金额大于可提现金额"),
          duration: 3000,
        });
        return false;
      }

      if (Number(this.money) < Number(this.min_withdraw_amount)) {
        this.$toast({
          background: "#a244aa",
          message: this.$t("提现金额小于最低提现金额"),
          duration: 3000,
        });
        return false;
      }

      //验证电话号码
      if (this.chave_pix != "PIX_PHONE") {
        let phone_reg = /^\d{9,}$/;
        if (!phone_reg.test(this.phone_number)) {
          this.$toast({
            background: "#a244aa",
            message: this.$t("手机号码不正确"),
            duration: 3000,
          });
          return false;
        }
      }
      // 验证邮箱
      // if (this.chave_pix === "PIX_EMAIL") {
      //   let email_reg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      //   if (!email_reg.test(this.email)) {
      //     this.$toast({
      //       background: "#a244aa",
      //       message: "O endereço de e-mail está incorreto",
      //       duration: 3000,
      //     });
      //     return false;
      //   }
      // }

      //验证CPF
      if (this.cpf.length < 9 || this.chave_pix.length > 11) {
        this.$toast({
          background: "#a244aa",
          message: this.$t("CPF不正确"),
          duration: 3000,
        });
        return false;
      }

      //终于通过验证了
      this.show_pay = true;
    },
  },
};
</script>


<style lang="less" scoped>
@import "../../assets/css/variables.less";
/deep/ .van-nav-bar--fixed {
  z-index: 2;
}
/deep/ .van-nav-bar {
  background: @secondary-color;
}

/deep/ .van-nav-bar .van-icon {
  color: #fff;
}

/deep/ .van-nav-bar__title {
  color: #fff;
}
/deep/.van-tab__text {
  font-size: 0.3rem;
  color: #fff;
}
/deep/.van-tabs__line {
  background: @ButtonColor;
  height: 0.04rem;
}
/deep/.van-cell {
  font-size: 0.3rem;
  border-radius: 0.14rem;
  padding: 0 0.2rem;
  height: 1rem;
  border: 0.01rem solid @bodercolor!important;
  background-color: @secondary-color;
  display: flex;
  align-items: center;
}
/deep/ .van-cell::after {
  border: none;
}
/deep/ .van-field__label {
  width: auto;
}
/deep/ .van-field__label span {
  color: #fff !important;
}
/deep/ .van-button--primary {
  width: 100%;
  background-color: @rechargeColor;
  border: none;
  height: 1rem;
  border-radius: 0.2rem;
}
/deep/.van-button__text {
  color: @vipTextMoneyColor!important;
  font-size: 0.3rem;
}
/deep/ .van-popup--center {
  width: 90%;
  padding: 0.3rem;
  background-color: @secondary-color;
}
::v-deep .van-field__control::-webkit-input-placeholder {
  color: @popupTextColor;
}
.popup_title {
  text-align: center;
  font-size: 0.4rem;
  color: #fff;
  margin-bottom: 0.4rem;
}
.select_items {
  display: flex;
  justify-content: space-between;
  padding-top: 0.2rem;
  padding-bottom: 0.4rem;
  padding-left: 0.5rem;
}
.flex_select {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
select {
  height: 0.7rem;
  border: 0.01rem solid @bodercolor;
  // padding-left: 0.4rem;
  // margin-left: 0.3rem;
  font-size: 0.26rem;
  color: @popupTextColor;
}
.input_item {
  margin-bottom: 0.4rem;
}

select {
  border-radius: 0.5rem;
  color: #fff;
  background-color: @secondary-color;
}
// @media (min-width: @maxWidth) {
//   :deep(.van-sticky) {
//     position: static !important;
//   }
// }
.bonus {
  color: @popupTextColor;
  margin-right: 0.3rem;
  font-size: 0.35rem;
  margin-top: 0.13rem;
  display: flex;
  align-items: center;
  span {
    color: @rechargeColor!important;
  }
}
.m-wrap path {
  fill: @rechargeColor;
}
.stroke_path {
  stroke: @primary-color;
}
.addSvg {
  fill: @ButtonColor;
}
.left_svg {
  fill: @popupTextColor;
  transform: rotate(180deg);
}
.addText {
  font-size: 0.3rem;
  color: @popupTextColor;
  margin-left: 0.3rem;
}
.lock_icon {
  font-size: 0.45rem;
  color: #fff;
}
.fst_pw {
  width: 94%;
  margin: 0.2rem auto 0.2rem auto;
}
.vantTabs {
  :deep(.van-sticky) {
    width: 100%;
    max-width: @maxWidth;
    // left: 50%;
    // transform: translateX(-50%);
  }
  :deep(.van-tabs__wrap) {
    height: 0.88rem;
    .van-tabs__nav {
      padding-left: 0;
      padding-right: 0;
      background-color: @secondary-color;
    }
    .van-tab {
      padding: 0 0.2rem;
      .van-tab__text {
        font-size: 0.32rem;
      }
      &.van-tab--active {
        span {
          color: @rechargeColor;
        }
      }
    }
    .van-tabs__line {
      background-color: @rechargeColor;
    }
  }
}
/deep/ .van-tabs__nav {
  padding-left: 0;
  padding-right: 0;
  background-color: @secondary-color;
}
.left_div {
  display: flex;
  align-items: center;
  border-bottom: 0.01rem solid @bodercolor;
  background-color: @secondary-color;
  .left {
    margin-left: 0.3rem;
    margin-top: 0.2rem;
    svg {
      fill: #fff;
    }
  }
}
.password_title {
  font-size: 0.3rem;
  color: #fff;
  line-height: 0.5rem;
}
.password {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .password_title {
    font-size: 0.3rem;
    color: #fff;
  }
}
.wdAble {
  margin-left: 0.2rem;
}
.rmoney {
  color: @ButtonColor!important;
  border-bottom: 0.01rem solid @ButtonColor;
}
.wdAble svg {
  fill: @ButtonColor;
}
.money_title {
  font-size: 0.3rem;
}
.ablewd ul {
  width: 100%;
  padding: 0.3rem 0;
  display: flex;
  align-items: center;
  margin: initial;
}
.ablewd ul li {
  flex: 1;
  border: thin solid @ButtonColor;
  box-sizing: border-box;
  color: @ButtonColor;
  height: 1rem;
  border-radius: 0.2rem;
  display: flex;
  font-size: 0.2rem;
  justify-content: center;
  align-items: center;
  position: relative;
  text-align: center;
}
.ablewd ul li span {
  color: @ButtonColor!important;
}
.choseDiv {
  position: absolute;
  bottom: -0.03rem;
  right: -0.01rem;
}
.addAccount {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: @secondary-color;
  border: thin solid @bodercolor;
  border-radius: 0.14rem;
  font-size: 0.22rem;
  height: 1rem;
  margin-bottom: 0.5rem;
  text-indent: 0.05rem;
  padding: 0 0.15rem;
  position: relative;
  box-sizing: content-box;
}
.left_add {
  display: flex;
  align-items: center;
}
.order-status {
  width: 100%;
  box-sizing: border-box;
  //   padding: 0.1rem 0 0.1rem 15px;
  padding: 0.26316rem 0.26316rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  //   border-bottom: thin solid #e5e5e5;
}
.mmm {
  //   width: 100%;
  font-weight: 700;
  color: gold;
}
.money3 {
  //   width: 95%;
  margin: 0 auto;
  padding: 10px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  //border-bottom: thin solid rgba(126, 126, 126, 0.1);
}
.unpay {
  // width: 60px;
  //   padding: 0 15px;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #fff;
  color: #fc661e;
  //background:  linear-gradient(90deg, #3FBBFE 0%, #A541FF 100%);
}
.status {
  // width: 60px;
  //   padding: 0 15px;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  //background: linear-gradient(to right, rgb(166, 0, 146), rgb(97, 17, 207));
}
.order {
  font-size: 0.3rem;
}
.jinbi {
  height: 0.32rem;
  margin-left: 0.2rem;
}
.refresh_btn {
  width: 0.4rem;
  height: 0.4rem;
  margin-left: 0.1rem;
}
.logo {
  width: 100%;
  text-align: center;
  img {
    width: 80%;
  }
}
.myteam-bg {
  width: 100%;
  height: 3rem;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
}

.cantc {
  background-color: rgb(22, 22, 19) !important;
  font-weight: 700;
}

.base-header {
  position: relative;
  height: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 92%;
  margin: 0 auto 0.2rem auto;
  border-radius: 0.2rem;
  overflow: hidden;
  z-index: 1;
  border: thin solid #0f69e8;
  box-sizing: border-box;
  padding: 5px 5px;
}

.big_tit {
  font-size: 0.35rem;
  text-align: center;
  width: 49%;
  height: 0.7rem;
  line-height: 0.7rem;
  color: #ffffff;
  border-radius: 0.1rem;
}
.recharge-one {
  width: 90%;
  margin: 0 auto 0.3rem auto;
  border-radius: 8px;
  color: #fff;
  overflow: hidden;
  position: relative;
  //border: 1px solid #895DB3;
  background: @secondary-color;
  padding: 0 0;
  font-size: 0.3rem;
}

.is-active {
  color: #ffffff;
  background-image: linear-gradient(
    90deg,
    rgba(3, 38, 96, 0.84) 0,
    rgba(3, 38, 96, 0.84) 0,
    rgb(27, 64, 119) 100%,
    rgb(27, 64, 119) 100%
  );
}

.fee {
  color: #fff;
  margin-top: 0.2rem;
}

.amount-input {
  height: 1rem;
  width: 100%;
  background-color: @secondary-color;
  //border: thin solid #293548;
  border: none;
  margin-top: 10px;
  font-size: 14px;
  color: white;
  text-indent: 10px;
  border-radius: 5px;
  //background: transparent;
  // font-weight: 700;
  box-sizing: border-box;
  border: 0.01rem solid #902f46 !important;
  //box-sizing: border-box;
}
.selectpix {
  // color: #e5c616 !important;
  font-size: 0.33rem;
  color: @textcolor3!important;
  font-size: 0.3rem;
  background-color: @secondary-color !important; /* 设置下拉选择框的背景颜色 */
}

.amount-input::placeholder {
  font-size: 0.33rem;
  color: @textcolor3;
}

.enther {
  // width: 92%;
  // margin: 15px auto 10px auto;
  box-sizing: border-box;
  // background-color: @secondary-color;
  padding: 0.3rem 0.2rem;
  border-bottom: 0.01rem solid @bodercolor;
}

.endes {
  color: #fff;
  font-size: 0.32rem;
  margin: 0;
}

.desc-num {
  margin-left: 0.1rem;
  color: gold;
  font-size: 0.35rem;
  font-weight: 700;
}

.desc-ab {
  text-align: left;
  box-sizing: border-box;
}

.left-ab {
  width: 100%;
  height: 30px;
  color: #fff;
  display: flex;
  align-items: center;
}
.right-ab {
  width: 100%;
  height: 30px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.ablewd {
  // width: 90%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  padding: 0.2rem;
  box-sizing: border-box;
  border-bottom: 0.01rem solid @bodercolor;
  background-color: @secondary-color;
}

.free-count {
  color: #989da6;
}

.basic_btn {
  background: #fff;
  margin: 15px auto 0;
  background-size: 100%;
  color: #132816;
  font-weight: 700;
}

.withdraw_wrap {
  width: 100%;
  height: 100vh;
  // height: auto;
  // padding-top: 0.2rem;
  //background-color: rgba(0,0,0,0.5);
  background-color: @activityColor;
}

.sbtn {
  margin: 0.5rem auto 0.5rem auto;
  width: 92%;
  border-radius: 0.2rem;
  font-size: 0.35rem;
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  background: @anttextcolor;
  color: @primary-color;
}
</style>
